import { Row, Typography } from 'antd';
import { CheckSquareOutlined } from '@ant-design/icons';

import { IItemOption } from '../../../../SimuladorInteligente/interfaces';
import BaseNodeContainer from '../../BaseNodeContainer';
import Option from './components/Option';

export default function OptionsNode(node: any) {
  const options = node.data.options as IItemOption[] | undefined;
  const isMultiple = node.data.allow_multiple_options as boolean | undefined;

  return (
    <BaseNodeContainer
      node={node}
      title={"Opções"}
      IconComponent={<CheckSquareOutlined />}
      showDefaultSourceConnector={!!isMultiple}
      defaultMessages={node.defaultMessages}
      defaultInputInstructions={node.defaultInputInstructions}
      handlePosition={40}
      onPressLink={node.onPressAddLinkedNode}
    >
      <div
        style={{
          padding: "0px 12px 4px"
        }}
      >
        <Typography.Title level={5}>Alternativas:</Typography.Title>

        <Row
          style={{
            flexDirection: 'column',
          }}
        >
          {
            options?.map((option, index: number) => (
              <Option
                key={option.text}
                hideBorderBottom={index >= (options.length - 1)}
                option={option}
                node={node}
                hideOptionsConnector={!!isMultiple}
                onPressAddLinkedNode={node.onPressAddLinkedNode}
              />
            ))
          }
        </Row>
      </div>
    </BaseNodeContainer>
  );
}